import React, { useState } from 'react';

const Avatar = ({ src, size = 48, className = "" }) => {
    const [hasError, setHasError] = useState(false);

    // Si src es "avatar_X", mapeamos a la carpeta public/iconos
    const isGraphicAvatar = src && typeof src === 'string' && src.startsWith('avatar_');
    const isExternalUrl = src && typeof src === 'string' && (src.startsWith('http') || src.startsWith('https'));

    const avatarUrl = isGraphicAvatar ? `/icons/${src}.png` : (isExternalUrl ? src : null);

    const containerStyle = {
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.05)',
        overflow: 'hidden',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        fontSize: `${size * 0.5}px`
    };

    // Si hubo error o no hay imagen válida, mostrar fallback
    if (hasError || (!isGraphicAvatar && !isExternalUrl)) {
        return (
            <div className={`avatar-container ${className}`} style={containerStyle}>
                {(!hasError && !isGraphicAvatar && !isExternalUrl && src) ? src : '👤'}
            </div>
        );
    }

    return (
        <div className={`avatar-container ${className}`} style={containerStyle}>
            <img
                src={avatarUrl}
                alt="Avatar"
                style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                referrerPolicy="no-referrer"
                onError={() => setHasError(true)}
            />
        </div>
    );
};

export default Avatar;
